(function () {
    'use strict';

    angular
        .module('app.shared')
        .filter('yesOrNo', yesOrNoFilterFactory);

    yesOrNoFilterFactory.$inject = [];
    function yesOrNoFilterFactory() {
        return function yesOrNoFilter(input) {
            return input == null ? null : !!input ? 'Yes' : 'No';
        }
    }
})();